import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveSecondaryCriteriaTemplate from "./retrieveSecondaryCriteriaTemplate";
import * as editSecondaryCriteriaTemplate from "./editSecondaryCriteriaTemplate";

const initialState: State = {
  retrieveSecondaryCriteriaTemplate:
    retrieveSecondaryCriteriaTemplate.initialState,
  editSecondaryCriteriaTemplate: editSecondaryCriteriaTemplate.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveSecondaryCriteriaTemplate:
    retrieveSecondaryCriteriaTemplate.reduceState,
  editSecondaryCriteriaTemplate: editSecondaryCriteriaTemplate.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveSecondaryCriteriaTemplate.createSelector(
      () => getState().retrieveSecondaryCriteriaTemplate,
    ),
    ...editSecondaryCriteriaTemplate.createSelector(
      () => getState().editSecondaryCriteriaTemplate,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
